export default __webpack_public_path__ + "static/media/sowmz-guitar-fixed.98aba5cc.jpg";